import { FULL_COLUMN_MAP, FULL_COLUMN_ORDER } from '../consts';
import { CatalogOutputRow } from '../types';

export const getCatalogExcelSheetData = (rows: CatalogOutputRow[]) => {
    const columnKeys = FULL_COLUMN_ORDER.filter((key) =>
        rows.some((row) => row[key] !== undefined),
    );
    const headers = columnKeys.map((key) => FULL_COLUMN_MAP[key]);
    const dataRows = rows.map((row) => columnKeys.map((key) => row[key]));

    return [headers, ...dataRows];
};
